module.exports = __webpack_public_path__ + "static/example-01-main-03e46ca6dc41926f41176d55cc600ee3.png";